import React__default from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const TooltipTrigger = /*#__PURE__*/ React__default.forwardRef(({ id , isActive: isActive1 , setIsActive , isTouch , 'aria-label': ariaLabel , label , renderLabel , theme ='primary' , iconName ='questionmark-filled' ,  }, ref)=>{
    const { getLabel  } = useIntl();
    const triggerRef = React__default.useRef(null);
    // Touch device handlers
    const handleDocumentClick = React__default.useCallback((e)=>{
        // Check if the clicked target is not equal to our trigger, preventing the tooltip to re-open immediately
        setIsActive((isActive)=>{
            if (isActive && triggerRef.current && !triggerRef.current.contains(e.target)) {
                return false;
            }
            return isActive;
        });
    }, [
        setIsActive
    ]);
    React__default.useEffect(()=>{
        if (!isTouch) {
            return;
        }
        document.addEventListener('touchend', handleDocumentClick);
        return ()=>document.removeEventListener('touchend', handleDocumentClick)
        ;
    }, [
        isTouch,
        handleDocumentClick
    ]);
    const handleTriggerClick = React__default.useCallback(()=>{
        isTouch && setIsActive((isActive)=>!isActive
        );
    }, [
        isTouch,
        setIsActive
    ]);
    // Non-touch handlers
    const handleTriggerMouseOver = React__default.useCallback(()=>{
        !isTouch && setIsActive(true);
    }, [
        isTouch,
        setIsActive
    ]);
    const handleTriggerMouseLeave = React__default.useCallback(()=>{
        // this timeout allows a user to move it's cursor from the trigger to the tooltip to keep the tooltip open
        !isTouch && setTimeout(()=>setIsActive(false)
        , 100);
    }, [
        isTouch,
        setIsActive
    ]);
    const handleKeyPress = (e)=>{
        if (e.key === 'Enter') {
            !isTouch && setIsActive(true);
            if (!isTouch && isActive1) {
                setIsActive(false);
            }
        }
        if (e.key === 'Escape') {
            setIsActive(false);
        }
    };
    const buttonClass = classnames('tooltip__button', {
        'tooltip__button--active': isActive1,
        'tooltip__button--primary': theme === 'primary',
        'tooltip__button--black': theme === 'black',
        'tooltip__button--grey': theme === 'grey',
        'tooltip__button--white': theme === 'white'
    });
    return /*#__PURE__*/ React__default.createElement("div", {
        ref: triggerRef
    }, /*#__PURE__*/ React__default.createElement("button", {
        type: "button",
        "aria-label": ariaLabel || getLabel('common.tooltip'),
        "aria-describedby": id,
        "aria-expanded": isActive1,
        className: buttonClass,
        ref: ref,
        onClick: handleTriggerClick,
        onMouseOver: handleTriggerMouseOver,
        onMouseLeave: handleTriggerMouseLeave,
        onFocus: ()=>null
        ,
        onKeyUp: handleKeyPress
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        className: "tooltip__icon",
        name: iconName,
        width: 18,
        height: 18
    }), renderLabel && label));
});

export { TooltipTrigger };
//# sourceMappingURL=TooltipTrigger.js.map
